export default __webpack_public_path__ + "static/media/MariOlman.15f08f34.jpg";